<template>
    <div class="dropdown dropdown-user" v-if="user">
        <a href="" class="user dropdown-toggle" data-toggle="dropdown" id="dropdown-user" aria-expanded="false">
            <div class="avatar"
                 :style="{'background-image': avatar ? getNameOfAvatar(avatar) : 'url(/img/svg/emptyAvatar.png)'}">
            </div>
        </a>
        <div class="dropdown-menu" aria-labelledby="dropdown-user">
            <div class="my-account">
                <div
                    class="avatar"
                    :style="{'background-image': avatar ? getNameOfAvatar(avatar): 'url(/img/svg/emptyAvatar.png)'}">
                    <div class="user-status on-line"></div>
                </div>
                <div class="person-wrap">
                    <div class="name">{{user.name ?? ''}} {{user.last_name ?? ''}}</div>
                    <a href="/master-admin/user/profile" class="btn btn--secondary">Edit Profile</a>
                </div>
            </div>
            <div class="other-users-online-list sep-line">
                <h6 v-if="listOfOnlineUsers.length > 0">Other users online</h6>
                <h6 v-else>No users online</h6>
                <ul>
                    <li
                        v-for="otherUser in listOfOnlineUsers"
                        :key="otherUser.id"
                    >
                        <div class="user-info">
                            <div
                                class="avatar"
                                :style="{'background-image': otherUser.avatar ? getNameOfAvatar(otherUser.avatar): 'url(/img/svg/emptyAvatar.png)'}"
                            >
                                <div class="user-status on-line"></div>
                            </div>
                            <div class="name">{{otherUser.name ?? ''}} {{otherUser.last_name ?? ""}}</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="sep-line">
                <a class="dropdown-item " href="/user/logout"><img src="/img/logout.png" alt="logout"> Logout</a>
            </div>
        </div>
    </div>

</template>


<script>
import ProfileServices from "./services/ProfileServices";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";

export default {
    name: 'ProfileModal',
    mixins: [StyleHandler],
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            listOfOnlineUsers: [],
            avatar: this.user.avatar ?? null,
        }
    },
    methods: {
        async getListOfOnlineUsers() {
            const {data: response} = await ProfileServices.getOnlineUsers()
            this.listOfOnlineUsers = response
        }
    },
    mounted() {
        this.getListOfOnlineUsers()
    }

}

</script>


<style scoped>

</style>
